module.exports = __webpack_public_path__ + "img/browsers.b4d664be.svg";